import React from 'react';

export const WhatsAppIcon = () => {
    return (
        <svg
            width="20"
            height="21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.05 20.29a9.95 9.95 0 0 1-5.06-1.38l-.36-.22-3.76.98 1-3.64-.23-.38A9.83 9.83 0 0 1 .12 10.4a9.92 9.92 0 0 1 19.86.01 9.92 9.92 0 0 1-9.93 9.89Zm3.4-8.37c.28.1 1.75.81 2.05.96.3.15.5.23.57.35.08.12.07.72-.17 1.41-.25.7-1.45 1.33-2.02 1.42a4.3 4.3 0 0 1-1.88-.12c-.58-.18-1.15-.39-1.7-.63-3-1.29-4.95-4.29-5.1-4.49-.15-.2-1.22-1.6-1.22-3.07 0-1.46.77-2.18 1.04-2.48a1.1 1.1 0 0 1 .8-.37l.57.01c.19.01.43-.07.67.51.25.6.85 2.06.92 2.2.08.16.13.33.03.53s-.15.32-.3.5c-.15.17-.31.38-.45.51-.15.15-.3.31-.13.61.18.3.77 1.27 1.66 2.06 1.14 1.01 2.1 1.32 2.4 1.47.3.15.48.13.65-.07.17-.2.75-.87.95-1.17.2-.3.4-.24.67-.14Z"
                fill="#F8F6DF"
            />
        </svg>
    );
};
